import React from "react"
import {
  type IconProps,
  iconColorCss,
  iconSizeCss,
} from "@myvp/shared/src/styles/icon-utils"

const ChartTrendingUp = (props: IconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    focusable="false"
    css={[iconColorCss(props.color), iconSizeCss(props.size)]}
  >
    <path
      d="M11.0918 19.1533V14.9044C11.0918 14.4351 11.4988 14.0547 12.0009 14.0547C12.503 14.0547 12.91 14.4351 12.91 14.9044V19.1533C12.91 19.6226 12.503 20.003 12.0009 20.003C11.4988 20.003 11.0918 19.6226 11.0918 19.1533Z"
      fill="var(--color)"
    />
    <path
      d="M14.7266 19.1418V13.1935C14.7266 12.7242 15.1336 12.3438 15.6357 12.3438C16.1377 12.3438 16.5448 12.7242 16.5448 13.1935V19.1418C16.5448 19.6112 16.1377 19.9916 15.6357 19.9916C15.1336 19.9916 14.7266 19.6112 14.7266 19.1418Z"
      fill="var(--color)"
    />
    <path
      d="M18.3633 19.1425V9.79507C18.3633 9.32576 18.7703 8.94531 19.2724 8.94531C19.7745 8.94531 20.1815 9.32576 20.1815 9.79507V19.1425C20.1815 19.6118 19.7745 19.9922 19.2724 19.9922C18.7703 19.9922 18.3633 19.6118 18.3633 19.1425Z"
      fill="var(--color)"
    />
    <path
      d="M20.4482 3.24889C20.8032 2.91704 21.3787 2.91704 21.7337 3.24889C22.0888 3.58074 22.0888 4.11865 21.7337 4.45051L13.8741 11.798L13.8732 11.7971C13.7467 11.9154 13.5973 12.0102 13.432 12.0743C13.2663 12.1386 13.0885 12.1714 12.9091 12.1714C12.7297 12.1714 12.5518 12.1386 12.3862 12.0743C12.2207 12.0101 12.0706 11.9156 11.9441 11.7971L9.27269 9.30095L3.55177 14.6476C3.19673 14.9795 2.62125 14.9795 2.26624 14.6476C1.91126 14.3158 1.91124 13.7779 2.26624 13.446L8.30944 7.7981L8.40887 7.71346C8.6515 7.52769 8.9572 7.4255 9.27358 7.4255L9.40764 7.43131C9.71969 7.46021 10.0131 7.58914 10.2368 7.7981H10.2377L12.9091 10.2951L20.4482 3.24889Z"
      fill="var(--color)"
    />
    <path
      d="M3.81836 19.149V16.5998C3.81836 16.1305 4.22538 15.75 4.72746 15.75C5.22954 15.75 5.63656 16.1305 5.63656 16.5998V19.149C5.63656 19.6184 5.22954 19.9988 4.72746 19.9988C4.22538 19.9988 3.81836 19.6184 3.81836 19.149Z"
      fill="var(--color)"
    />
    <path
      d="M7.45508 19.1418V13.1935C7.45508 12.7242 7.8621 12.3438 8.36418 12.3438C8.86626 12.3438 9.27327 12.7242 9.27327 13.1935V19.1418C9.27327 19.6112 8.86626 19.9916 8.36418 19.9916C7.8621 19.9916 7.45508 19.6112 7.45508 19.1418Z"
      fill="var(--color)"
    />
  </svg>
)

export default ChartTrendingUp
